import type { AppColors } from "../utilities/appColors";
import { appNeutralColors } from "./appNeutralColors";

// TODO: these are just taken from Word, decide if this is really what we want to be the default
export const defaultAppColors: AppColors = {
  shade30: "#0E336A",
  shade20: "#002050",
  shade10: "#124078",
  primary: "#2B579A",
  tint10: "#3C65A4",
  tint20: "#4A78B0",
  tint30: "#7DA3C6",
  tint40: "#A5B9D1",
};

// Color palette used for all controls in app commanding UI
export const defaultAppColorPalette = {
  ...defaultAppColors,
  ...appNeutralColors,
};
